"use client"

import type { OwnedEntry } from "@/modules/transaksi/domain/types-ownership"
import { bacaMuatanMigrasiDomain } from "./domain-migration"

export type { OwnedEntry }

const KEY = "ownedTransactionTokens"
const KEY_LEGACY = "transactionHistory"
const KEY_LEGACY_SUDAH_MIGRASI = "transactionHistory_migrated"
const MAKS_ENTRI = 50

function bacaDaftarToken(): OwnedEntry[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((it) => it && typeof it.transactionId === "string" && typeof it.token === "string")
  } catch {
    return []
  }
}

function tulisDaftarToken(daftar: OwnedEntry[]) {
  localStorage.setItem(KEY, JSON.stringify(daftar.slice(0, MAKS_ENTRI)))
}

function bacaDaftarLegacy(): { transactionId?: string }[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY_LEGACY) || "[]")
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function gabungkanToken(masuk: OwnedEntry[]) {
  if (masuk.length === 0) return
  try {
    const ada = bacaDaftarToken()
    const idAda = new Set(ada.map((it) => it.transactionId))
    tulisDaftarToken([...ada, ...masuk.filter((it) => !idAda.has(it.transactionId))])
  } catch (error) {
    console.error("Gagal menggabungkan token hasil migrasi domain:", error)
  }
}

function gabungkanRiwayatLegacy(idMasuk: string[]) {
  if (idMasuk.length === 0 || localStorage.getItem(KEY_LEGACY_SUDAH_MIGRASI) === "1") return
  try {
    const ada = bacaDaftarLegacy()
    const idAda = new Set(ada.map((it) => it?.transactionId))
    const tambahan = idMasuk.filter((id) => !idAda.has(id)).map((transactionId) => ({ transactionId }))
    localStorage.setItem(KEY_LEGACY, JSON.stringify([...ada, ...tambahan]))
  } catch (error) {
    console.error("Gagal menggabungkan riwayat lama hasil migrasi domain:", error)
  }
}

export function terapkanMigrasiDomain(): boolean {
  const muatan = bacaMuatanMigrasiDomain()
  if (!muatan) return false

  gabungkanToken(muatan.owned)
  gabungkanRiwayatLegacy(muatan.legacy)
  return true
}

export function ambilSemuaOwnershipToken(): OwnedEntry[] {
  terapkanMigrasiDomain()
  return bacaDaftarToken()
}

export function simpanOwnershipToken(transactionId: string, token: string, username?: string, email?: string) {
  if (!transactionId || !token) return
  try {
    const daftar = ambilSemuaOwnershipToken()
    const idx = daftar.findIndex((it) => it.transactionId === transactionId)
    if (idx !== -1) {
      daftar[idx].token = token
      if (username) daftar[idx].username = username
      if (email) daftar[idx].email = email
    } else {
      daftar.unshift({ transactionId, token, username, email })
    }
    tulisDaftarToken(daftar)
  } catch (error) {
    console.error("Gagal menyimpan ownership token:", error)
  }
}

export function pernahPunyaUsername(username: string): boolean {
  if (!username) return false
  const target = username.trim().toLowerCase()
  return ambilSemuaOwnershipToken().some((it) => it.username?.trim().toLowerCase() === target)
}

export function emailTerbukti(username: string): string | null {
  if (!username) return null
  const target = username.trim().toLowerCase()
  return ambilSemuaOwnershipToken().find((it) => it.username?.trim().toLowerCase() === target && it.email)?.email ?? null
}

export function ambilOwnershipToken(transactionId: string): string | null {
  return ambilSemuaOwnershipToken().find((it) => it.transactionId === transactionId)?.token || null
}

export function hapusOwnershipToken(transactionId: string) {
  try {
    tulisDaftarToken(ambilSemuaOwnershipToken().filter((it) => it.transactionId !== transactionId))
  } catch {
    return
  }
}

export function ambilIdRiwayatLegacy(): string[] {
  terapkanMigrasiDomain()
  if (localStorage.getItem(KEY_LEGACY_SUDAH_MIGRASI) === "1") return []
  return bacaDaftarLegacy()
    .map((it) => it?.transactionId)
    .filter((id): id is string => typeof id === "string")
}

export function tandaiLegacyHistorySudahDimigrasi() {
  try {
    localStorage.setItem(KEY_LEGACY_SUDAH_MIGRASI, "1")
  } catch {
    return
  }
}
